import React, { type MouseEvent, type ReactNode, useRef } from 'react';

import { gsap } from 'gsap';

import { MagnetismWrapper } from './styles';

interface YatMagnetismProps {
    className?: string;
    children: ReactNode;
}

const YatMagnetism = ({ className, children }: YatMagnetismProps) => {
    const usingMouse = window.matchMedia('(pointer: fine)').matches;
    const wrapperRef = useRef() as React.MutableRefObject<HTMLDivElement>;

    const animateTo = (x: number, y: number) => {
        gsap.to(wrapperRef.current, {
            x: x,
            y: y,
            duration: 0.75,
            ease: 'power2.out',
        });
    };

    const handleMouseMove = (event: MouseEvent<HTMLElement>) => {
        if (!wrapperRef.current || !usingMouse) return;

        const x = wrapperRef.current.getBoundingClientRect().left;
        const y = wrapperRef.current.getBoundingClientRect().top;

        const width = wrapperRef.current.clientWidth / 2;
        const height = wrapperRef.current.clientHeight / 2;

        const centerX = x + width;
        const centerY = y + height;

        const deltaX = Math.floor(centerX - event.clientX) * -0.8;
        const deltaY = Math.floor(centerY - event.clientY) * -0.8;

        animateTo(deltaX, deltaY);
    };

    const handleMouseLeave = () => {
        if (wrapperRef.current && usingMouse) animateTo(0, 0);
    };

    return (
        <MagnetismWrapper
            ref={wrapperRef}
            className={className}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
        >
            {children}
        </MagnetismWrapper>
    );
};

export default YatMagnetism;
